import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var MonitorSVG = function MonitorSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M2 21a2 2 0 002 2h9v3h-3a1 1 0 000 2h12a1 1 0 000-2h-3v-3h9a2 2 0 001.1-.3 2.3 2.3 0 00.6-.6A2 2 0 0030 21v-2H2zM29.7 4.9a2.3 2.3 0 00-.6-.6A2 2 0 0028 4H4a2 2 0 00-2 2v11h28V6a2 2 0 00-.3-1.1z"
  }));
};
MonitorSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(MonitorSVG);